import { NameDto } from '../../Common/Types'

export interface SubscriptionDetailDetailsDto {
  id: string
  name: string | null
  description: string | null
  subscriptionId: string
  amount: number
  mappingId: string | null
  mappingText: string | null
  detailType: SubscriptionDetailTypeDto
  bundles: SubscriptionDetailBasicDto[]
  subscription: SubscriptionDto
}

interface SubscriptionDetailTypeDto {
  id: number
  name: string | null
  shortName: string | null
  description: string | null
}

interface SubscriptionDetailBasicDto {
  id: string
  name: string | null
  description: string | null
  subscriptionId: string
  detailType: {
    id: number
    name: string | null
    shortName: string | null
    description: string | null
  }
  amount: number
}

interface SubscriptionDto {
  id: string
  name: string | null
  description: string | null
  group: {
    id: string
    name: string
    type: NameDto
  }
  currency: { id: string; name: string }
  billingPeriod: NameDto
  subscriptionClassificationType: NameDto
  documentId: string | null
  enabled: boolean
  tradingAccountRequired: boolean
  order: number
  tickmillProduct: NameDto
  details: SubscriptionDetailDto[]
  platforms: SubscriptionPlatformDto[]
}

interface SubscriptionDetailDto {
  id: string
  name: string | null
  description: string | null
  subscriptionId: string
  detailType: SubscriptionDetailTypeDto
  amount: number
  mappingId: string | null
  mappingText: string | null
  bundles: SubscriptionDetailBasicDto[]
}

interface SubscriptionDetailTypeDto {
  id: number
  name: string | null
  shortName: string | null
  description: string | null
}

interface SubscriptionPlatformDto {
  subscriptionId: string
  platformType: NameDto
  tickmillCompany: NameDto
}

export enum SubscriptionDetailDetailsKey {
  name = 'subscription.name',
  type = 'subscription.group.type.name',
  level = 'detailType.shortName',
  mappingText = 'mappingText',
  amount = 'amount',
  currency = 'subscription.currency.id',
  enabled = 'subscription.enabled',
  order = 'subscription.order',
  product = 'subscription.tickmillProduct.name',
}

export enum SubscriptionDetailDetailsFilterKey {
  name = 'SubscriptionName',
  type = 'SubscriptionClassificationTypeId ',
  level = 'DetailTypeId',
}
